import { ViewModel,View, ObservableArray } from "binder"
import { SearchableSelectorBaseViewModel } from "src/common/reusableComponents/searchableSelectorBase/searchableSelectorBase-viewModel";
import { CellPhone, Phone, PhoneInputViewModel } from "src/common/utilities/phoneInput/phoneInput-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class ProviderSearchViewModel extends SearchableSelectorBaseViewModel<providerForSelector>{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    public getTypeId(): string {
        return "VM-9F6DE1C6-5711-49E6-917F-2EE8DF12E361";
    }

    protected async loadData(searchedText: string): Promise<providerForSelector[]> {
        let result = await ServerConnection.callServer('Complex/CrmServices/SearchProviders',{
            SearchText:searchedText,
            ResultCount:20,
        });
        return result.Providers.map(x=>this.convertSingle(x));
    }
    protected async loadById(id: string): Promise<providerForSelector> {
        let result = await ServerConnection.callServer('Complex/CrmServices/SearchProvidersById',{
            Id:id
        });    
        return this.convertSingle(result.Provider);
    }
    
    private convertSingle(dto:any):providerForSelector{
        var p = new providerForSelector(this);
        p.id = dto.Id;
        p.name = dto.Name;
        p.code = dto.Code;
        p.nationalCode = dto.NationalCode;
        // p.cellphones.update(...dto.CellPhones.map(x=>{
        //     let y = new CellPhone(p.phoneInput);
        //     y.countryCode = x.CountryCode;
        //     y.number = x.Number;
        //     return y;
        // }));
        // p.phones.update(...dto.Phones.map(x=>{
        //     let y = new Phone(p.phoneInput);
        //     y.countryCode = x.CountryCode;
        //     y.number = x.Number;
        //     y.cityCode = x.CityCode;
        //     return y;
        // }));
        // p.phoneInput.addCellPhone(...dto.Cellphones);
        // p.phoneInput.addPhone(...dto.phones);
        p.title = `${dto.Code} - ${dto.Name} - (${dto.NationalCode})`;
        return p;
    }
}

export class providerForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.phoneInput = new PhoneInputViewModel(this);
        this.phones = ObservableArray.create<Phone>();
        this.cellphones = ObservableArray.create<CellPhone>();
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set nationalCode(v: string) { this._nationalCode = v; } public get nationalCode(): string { return this._nationalCode;} private _nationalCode: string;
    public set phones(v: ObservableArray<Phone>) { this._phones = v; } public get phones(): ObservableArray<Phone> { return this._phones;} private _phones: ObservableArray<Phone>;
    public set cellphones(v: ObservableArray<CellPhone>) { this._cellphones = v; } public get cellphones(): ObservableArray<CellPhone> { return this._cellphones;} private _cellphones: ObservableArray<CellPhone>;
    public set phoneInput(v: PhoneInputViewModel) { this._phoneInput = v; } public get phoneInput(): PhoneInputViewModel { return this._phoneInput;} private _phoneInput: PhoneInputViewModel;
    
}
